import { useContext } from 'react';
import { postValidationContext } from '../contexts/PostValidationContext';

export function usePostValidation() {
  const value = useContext(postValidationContext);
  return value;
}
